import axios from 'axios'

const api = axios.create({ baseURL: `${process.env.REACT_APP_API}/receiving` })

const authHeaders = (multipart = false) => ({
  Authorization: `Bearer ${localStorage.getItem('receivingToken')}`,
  ...(multipart ? {} : { 'Content-Type': 'application/json' }),
})

const request = async (config) => {
  try {
    const response = await api.request(config)
    return response.data
  } catch (error) {
    if (error.response?.status === 401 && config.url !== '/authenticate') {
      localStorage.removeItem('receivingToken')
      localStorage.removeItem('receivingUser')
      window.location.assign('/receiving/login')
    }
    throw error
  }
}

export const receivingLogin = (payload) => request({ method: 'post', url: '/authenticate', data: payload })
export const receivingLogout = () => request({ method: 'post', url: '/logout', headers: authHeaders() })
export const lookupLabel = (code) => request({ method: 'get', url: `/lookup/${encodeURIComponent(code)}`, headers: authHeaders() })
export const searchTrackingNumbers = (storageGroupId, q) => request({ method: 'get', url: '/tracking-numbers', params: { storage_group_id: storageGroupId, q }, headers: authHeaders() })
export const getCustomerTransactions = (storageGroupId, customerId) => request({ method: 'get', url: '/tracking-numbers', params: { storage_group_id: storageGroupId, customer_id: customerId }, headers: authHeaders() })
export const searchCustomers = (storageGroupId, q) => request({ method: 'get', url: '/customers', params: { storage_group_id: storageGroupId, q }, headers: authHeaders() })
export const getLocations = (storageGroupId) => request({ method: 'get', url: '/locations', params: { storage_group_id: storageGroupId }, headers: authHeaders() })
export const receivePackage = (payload) => request({ method: 'post', url: '/packages', data: payload, headers: authHeaders(true) })
export const pullOutPackage = (packageId, scope) => request({ method: 'post', url: `/packages/${packageId}/pull-out`, data: { scope, confirmed: true }, headers: authHeaders() })

export const receivingError = (error, fallback = 'Something went wrong. Please try again.') => ({
  message: error.response?.data?.message || fallback,
  fields: error.response?.data?.errors || {},
})
